import type { ServiceType } from '@/legacy-src/types/GeneralStateType'
import type { TherapistType } from '@/legacy-src/types/TherapistStateType'

import { CartContext } from '@/src/domains/cart/contexts/Cart.context'

import { CartProviderGuards } from './CartProviderGuards'
import { useCartAutoVoucher } from './hooks/useCartAutoVoucher'
import { useCartState } from './hooks/useCartState'

interface CartProviderProps {
  children: React.ReactNode
  therapist: TherapistType
  service: ServiceType
}

export const CartProvider = ({ therapist, service, children }: CartProviderProps) => {
  const cart = useCartState({ therapistId: therapist.therapistId, serviceId: service.id, serviceType: service.type })

  useCartAutoVoucher({ voucher: cart.voucher, setVoucher: cart.setVoucher })

  return (
    <CartContext.Provider value={cart}>
      <CartProviderGuards />
      {children}
    </CartContext.Provider>
  )
}
